<template>
  <div class="wm_compact_panel">
    <slot />
  </div>
</template>
